import React, { useState } from "react";
import style from "../newUser/newUser.module.css";
import Input from "../../components/Input";
import { callback } from "chart.js/dist/helpers/helpers.core";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import axios from "axios";
import { BASE_URL } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import { _axios } from "../../utils/axios";

const CreateNewUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    employeeId: "",
    mobile: "",
    email: "",
    role: "Level 1",
    active: false,
  });

  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const mobileNumberChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    const valueChange = value.replace(/[^0-9]/g, '')
    console.log('valueChange', valueChange)
    if (e?.target.value.length < 11)
      setFormData({
        ...formData,
        [name]: valueChange,
      });
  };

  const handleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const isValid = emailRegex.test(formData.email);
    if (formData.name.length === 0) {
      ErrorToast("Please enter valid name")
      return
    }
    if (formData.email.length === 0 || !isValid) {
      ErrorToast("Please enter valid email")
      return
    }
    if (formData.mobile.length === 0 || formData.mobile.length < 10) {
      ErrorToast("Please enter a valid 10-digit mobile number")
      return
    }

    _axios.post(`${BASE_URL}/api/admin`,
      {
        "name": formData.name,
        "mobile": formData.mobile,
        "email": formData.email,
        "role": formData.role,
        "active": formData.active ? 1 : 0,
        "employeeId": formData.employeeId ?? ''
      })
      .then(function (response) {
        console.log('response', response);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        SuccessToast('Account Created')
        navigate('/add-user');

        // handle success

      })
      .catch(function (error) {
        // handle error
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message)
        }
        console.log('error', error);
      })
      .finally(function () {
        // always executed
      });
    // Handle form submission logic here, such as sending data to a server.
  };

  return (
    <div className={style.body} style={{ marginBottom: '70px' }}>
      <div className={style.divbodyheading}>
        <p className={style.bodytitle}>Create User</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={style.navbar}>
          <BoxComponent>
            <div className={`${style.userform}`}>
              <div className={style.formrow}>
                <div className={style.formgroup}>
                  {/* <label htmlFor="fullName">Name *</label> */}
                  <div className={style.loginText}>Name <span className="text-red-500">{' *'}</span></div>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>

                <div className={style.formgroup}>
                  {/* <label htmlFor="employeeId">Employee ID (Optional)</label> */}
                  <div className={style.loginText}>Employee ID (Optional)</div>
                  <input
                    type="text"
                    id="employeeId"
                    name="employeeId"
                    placeholder="Employee Id"
                    value={formData.employeeId}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className={style.formrow}>
                <div className={style.formgroup}>
                  {/* <label htmlFor="mobile">Mobile Number</label> */}
                  <div className={style.loginText}>Mobile Number <span className="text-red-500">{' *'}</span></div>
                  <input
                    type="number"
                    id="mobile"
                    name="mobile"
                    placeholder="Enter Mobile Number"
                    value={formData.mobile}
                    onChange={(e) => mobileNumberChange(e)}
                    onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                  />
                </div>
                <div className={style.formgroup}>
                  {/* <label htmlFor="emailId">Email ID</label> */}
                  <div className={style.loginText}>Email ID <span className="text-red-500">{' *'}</span></div>
                  <input
                    type="email"
                    id="emailId"
                    name="email"
                    placeholder="Enter Email ID"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className={style.formrow}>
                <div className={style.formgroup}>
                  {/* <label htmlFor="securityRoles">Security Roles</label> */}
                  <div className={style.loginText}>Access Level <span className="text-red-500">{' *'}</span></div>
                  <select
                    id="securityRoles"
                    name="role"
                    className="selectwhite"
                    value={formData.role}
                    onChange={handleInputChange}
                  >
                    {/* <option value="Applicant">Applicant</option> */}
                    <option value="Level 1">Level 1</option>
                    <option value="Level 2">Level 2</option>
                    <option value="Level 3">Level 3</option>
                    <option value="Accountant">Accountant</option>
                    <option value="System Admin">System Admin</option>
                  </select>
                </div>
                <div className={style.formgroup} >

                  <div className={style.footerActive}>
                    <label className={style.footerAct}>Activate User</label>
                    <div className={style.footerAct}>
                      <label className={style.toggleBtn}>
                        <input
                          type="checkbox"
                          checked={formData.active}
                          className={style.inputCheckbox}
                          onChange={() => setFormData({ ...formData, active: !formData.active })}
                        />
                        <span className={style.slider}></span>
                      </label>
                    </div>
                  </div>

                </div>
              </div>
              <div className={`${style.buttonSection} mt-10`}>
                <button className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300">Create</button>

                <button className="bg-black ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" onClick={() => navigate('/add-user')}>Close</button>
              </div>
            </div>
          </BoxComponent>
        </div>
      </form>
    </div>
  );
};

export default CreateNewUser;
